<script setup lang="ts">
import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";

import SearchInput from "@/components/ui/SearchInput/SearchInput.vue";

const { t } = useI18n();

const props = defineProps<{
  text: string | null;
}>();

const emit = defineEmits<{
  change: [text: string];
}>();

const internalText = ref(props.text || "");

// Sync internal state when props change (e.g., filters reset externally)
watch(
  () => props.text,
  (newText) => {
    internalText.value = newText || "";
  },
);

function handleEmit() {
  const normalizedNew = internalText.value.trim();
  const normalizedProp = props.text || "";

  if (normalizedNew !== normalizedProp) {
    emit("change", normalizedNew);
  }
}
</script>

<template>
  <SearchInput
    v-model="internalText"
    wrapper-class="issue-text-filter"
    size="small"
    :placeholder="t('issueSelector.filter.textSearch')"
    :aria-label="t('issueSelector.filter.textSearch')"
    @blur="handleEmit"
    @keyup.enter="handleEmit"
  />
</template>

<style lang="scss" scoped>
.issue-text-filter {
  flex: 1;
  max-width: 350px;
}
</style>
